<section class="w-full flex flex-col items-center justify-center px-4 lg:py-16 min-h-[calc(100vh-80px-64px)] lg:min-h-0">
  <app-galaxy-card class="w-full h-full lg:h-auto lg:max-w-6xl animate-fade-slide-up overflow-hidden" padding="none">
    <div galaxy-card-content class="relative w-full h-full">
      <!-- 🖼️ Imagen para Móvil --> 
      <img
        src="assets/hero.png" 
        alt="Promoción Eagle Tech - Móvil"
        class="w-full h-full object-cover lg:hidden animate-hero-glow"
      />
      <!-- 🖼️ Imagen para Escritorio -->
      <img 
        src="assets/hero-desktop.png"
        alt="Promoción Eagle Tech - Escritorio"
        class="hidden w-full object-cover lg:block lg:h-[550px]"
      />

      <!-- 🚀 Botón de Acción -->
    </div>
  </app-galaxy-card>
</section>

